// extracted by mini-css-extract-plugin
module.exports = {"HaveQuestions":"style_HaveQuestions__12lyH","Title":"style_Title__2Pw1S","SubTitle":"style_SubTitle__1z4dZ","Phone":"style_Phone__1aQaO","Email":"style_Email__2XJ4f"};